import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ThinCheckbox } from 'components/common/Styles';
import FlexBox from 'components/common/FlexBox';
import TextTableCell from 'components/common/table/TextTableCell';

const DocumentTemplateItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/documentTemplates/${data.documentTemplateId}`);
  }, [historyContext, data]);

  return (
    <TableRow key={data.documentTemplateId}>
      <TextTableCell content={data.templateName} />
      <TableCell>{data.templateCode}</TableCell>
      <TableCell align='center'>
        <ThinCheckbox disabled={true} size='small' checked={data.bulkPrintingYN} />
      </TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton type='edit' variant='text' color='primary' size='small' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton
            type='delete'
            variant='text'
            color='primary'
            size='small'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.documentTemplateId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

DocumentTemplateItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DocumentTemplateItem;
